import type { GetHashtagsSort } from './getHashtagsSort';

export type GetHashtagsParams = {
/**
 * 검색어 (해시태그 텍스트)
 */
query?: string;
/**
 * 정렬 기준
 */
sort?: GetHashtagsSort;
/**
 * 조회 시작 날짜 (ISO 8601 형식)
 */
startDate?: string;
/**
 * 조회 종료 날짜 (ISO 8601 형식)
 */
endDate?: string;
/**
 * 페이지 번호
 */
page?: number;
/**
 * 페이지 크기
 */
size?: number;
};
